import Tooltip from 'components/tooltip'
import { formatCurrency } from 'helpers'
import * as E from './doubleLineCardHeaderElements'

export const DoubleLineCardHeader = ({
  priveawayPrice,
  retailPrice,
  vehicleDescription,
}) => {
  let hasRetailPrice = retailPrice && retailPrice > priveawayPrice

  let retailPriceTitle =  'Recommended Retail Price'

  let tooltipText = 'The ' +
      (vehicleDescription ? vehicleDescription : 'vehicle') +
      ' can be acquired for less than the cost of the Recommended Retail Price of ' +
      formatCurrency(retailPrice) +
      ' by taking advantage of Oly’s fleet buying power and discounts, as well as the potential GST savings.'

  return (
    <div>
      <E.StyledCardHeader className="border-bottom-0">
        <div className="text-header">
          Your Oly Novated Lease Price
          {hasRetailPrice ? <sup> †</sup> : ''}
        </div>
        <E.StyledPriceDiv isGreen={hasRetailPrice}>
          {formatCurrency(priveawayPrice)}
        </E.StyledPriceDiv>
      </E.StyledCardHeader>

      {hasRetailPrice && (
        <E.StyledCardHeader nopadding className="border-bottom-0">
          <E.StyledCardHeaderText>
            <span className="mr-2">
              {retailPriceTitle} <sup>‡</sup>
            </span>
            <Tooltip text={tooltipText} />{' '}
          </E.StyledCardHeaderText>

          <E.StyledPriceDiv strikethrough>
            {formatCurrency(retailPrice)}
          </E.StyledPriceDiv>
        </E.StyledCardHeader>
      )}
    </div>
  )
}
